import React from 'react';
import './EIA.css'; // Create a CSS file for specific styles if needed
import Header4 from '../../components/header/Header2';
import ServicesHeroSection from '../../components/services_hero_section/ServicesHeroSection';
import Footer from '../../components/footer/Footer';
import backgroundimg from '../../assets/images/eia-2.jpg';
import ServicesOverviewSection from '../../components/services_overview_section/ServicesOverviewSection';
import img_eia_banner from '../../assets/images/img_peso1_banner.png'; // Replace with an appropriate image path
import { FaTree, FaChartLine, FaCogs, FaShieldAlt, FaComments, FaFileAlt, FaPaperPlane, FaCertificate } from 'react-icons/fa';
import ServicesBenefitsSection from '../../components/services_benefits_section/ServicesBenefitsSection';
import ServicesOurProcessSection from '../../components/services_our_process_section/ServicesOurProcessSection';
import ActsAndRulesSection from '../../components/acts_rules_section/ActsAndRulesSection';
import DocumentChecklist from '../../components/check_list_section/CheckListSection';

export default function EIA() {
  const benefits = [
    {
      icon: <FaTree />,
      title: 'Environmental Protection',
      text: 'Ensure compliance with environmental standards to protect ecosystems.',
    },
    {
      icon: <FaChartLine />,
      title: 'Sustainable Development',
      text: 'Facilitate development projects while minimizing environmental impact.',
    },
    {
      icon: <FaShieldAlt />,
      title: 'Regulatory Compliance',
      text: 'Avoid legal and financial liabilities by adhering to environmental laws.',
    },
    {
      icon: <FaCogs />,
      title: 'Operational Efficiency',
      text: 'Streamline your project with comprehensive environmental assessments.',
    },
  ];

  const steps = [
    {
      icon: <FaComments />,
      title: 'Initial Consultation',
      description: 'Discuss project requirements and scope of the assessment.',
    },
    {
      icon: <FaFileAlt />,
      title: 'Baseline Study',
      description: 'Gather data on existing environmental conditions of the site.',
    },
    {
      icon: <FaTree />,
      title: 'Impact Analysis',
      description: 'Evaluate potential environmental impacts of the proposed project.',
    },
    {
      icon: <FaPaperPlane />,
      title: 'Report Submission',
      description: 'Prepare and submit the Environmental Impact Assessment report.',
    },
    {
      icon: <FaCertificate />,
      title: 'Approval & Compliance',
      description: 'Obtain necessary environmental clearances and approvals.',
    },
  ];

  const acts = [
    'Environmental Protection Act, 1986',
    'Wildlife Protection Act, 1972',
    'Forest Conservation Act, 1980',
    'Air and Water Pollution Control Acts',
  ];

  const explanation =
    'Environmental Impact Assessments (EIA) ensure compliance with environmental regulations while promoting sustainable and eco-friendly development. They play a crucial role in mitigating the environmental impact of industrial, infrastructure, and development projects.';

  const checklistItems = [
    { name: 'Project Proposal', description: 'Provide a detailed description of the proposed project.' },
    { name: 'Baseline Environmental Data', description: 'Include data on air, water, and soil quality.' },
    { name: 'Environmental Impact Study', description: 'Prepare an initial analysis of potential impacts.' },
    { name: 'Mitigation Plans', description: 'Provide measures to address potential environmental risks.' },
  ];

  return (
    <>
      <Header4 />
      <ServicesHeroSection
        headline="Environmental Impact Assessment (EIA)"
        subheading="Ensure your project aligns with environmental regulations and promotes sustainability."
        ctaPrimary={{ text: 'Request Consultation', link: '/contact-us' }}
        ctaSecondary={{ text: 'Learn More', link: '/environment-impact-assesment' }}
        backgroundImage={backgroundimg} // Pass the background image here
      />

      <ServicesOverviewSection
        title="What is Environmental Impact Assessment (EIA)?"
        description="EIA is a vital process for assessing the environmental effects of a proposed project or development, ensuring compliance with laws and promoting sustainable practices."
        image={img_eia_banner} // Replace with a relevant image
        altText="Environmental Impact Assessment Process"
      />

      <ServicesBenefitsSection
        title="Why Conduct an Environmental Impact Assessment?"
        description="Understand the importance of EIA in minimizing environmental risks and ensuring sustainable development."
        benefits={benefits}
      />

      <ActsAndRulesSection
        title="Acts and Rules Covered"
        subtitle="Key Environmental Laws and Guidelines"
        acts={acts}
        explanation={explanation}
      />

      <ServicesOurProcessSection
        title="Our EIA Process"
        steps={steps}
      />

      <DocumentChecklist
        mainTitle="Complete Your Onboarding"
        checklistTitle="EIA Onboarding Document Checklist"
        items={checklistItems}
      />

      <Footer />
    </>
  );
}
